// Frontend/src/hooks/useResidentProfile.ts
import { useQuery } from "@tanstack/react-query";
import { getResidentProfile, type ResidentProfileResponse } from "@/api/residentAuth";

/**
 * Hook to get the current logged-in resident's profile
 */
export function useResidentProfile() {
  return useQuery<ResidentProfileResponse>({
    queryKey: ["residentProfile"],
    queryFn: getResidentProfile,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
